import axios from 'axios'

let cancelGetTransactions
let GetTransactionsCancelToken = axios.CancelToken
let cancelTopBanner
let TopBannerCancelToken = axios.CancelToken

export default {
  getTransactions: (page = 1, pagination = true, filters = {}) => {
    if (cancelGetTransactions !== undefined) {
      cancelGetTransactions()
    }
    return axios({
      method: 'get',
      url: '/transactions',
      cancelToken: new GetTransactionsCancelToken(function executor (c) {
        cancelGetTransactions = c
      }),
      params: { page: page, pagination: pagination, ...filters }
    })
  },
  getTransactionsByBudget: (page = 1, pagination = true, filters = {}) => {
    if (cancelGetTransactions !== undefined) {
      cancelGetTransactions()
    }
    return axios({
      method: 'get',
      url: '/transactions_budget',
      cancelToken: new GetTransactionsCancelToken(function executor (c) {
        cancelGetTransactions = c
      }),
      params: { page: page, pagination: pagination, ...filters }
    })
  },
  getUserReimbursements: (page = 1, pagination = true, filters = {}) => {
    if (cancelGetTransactions !== undefined) {
      cancelGetTransactions()
    }

    return axios({
      method: 'get',
      url: '/transactions/user_reimbursements',
      cancelToken: new GetTransactionsCancelToken(function executor (c) {
        cancelGetTransactions = c
      }),
      params: { page: page, pagination: pagination, ...filters }
    })
  },
  getTransaction: id => axios.get(`/transactions/${id}`),
  postTransactionMedia: (id, resource) =>
    axios.post(`/transactions/${id}/media_without_sign`, resource),
  // This is the old endpoint that signs everything
  // postTransactionMediaSigned: (id, resource) =>
  //   axios.post(`/transactions/${id}/media`, resource),
  putTransaction: (id, transactionInformation) =>
    axios.put(`/transactions/${id}/ignoring_mandatory`, transactionInformation),
  accountTransaction: (id) =>
    axios.put(`/transactions/${id}/accounted`, {}),
  unaccountTransaction: (id) =>
    axios.put(`/transactions/${id}/unaccounted`, {}),
  changeTransactionReceiptType: (id, type) => axios.put(`/media/${id}`, type),
  deleteTransactionReceipt: id => axios.delete(`/media/${id}`),
  getExport: async filters => {
    const config = {
      responseType: 'blob',
      params: {
        ...filters
      }
    }

    return axios.get(`/transactions/export`, config)
  },
  ignoreTransactionWarning: id => axios.put(`transaction_warnings/${id}/ignore`, {}),
  getExportBackground: filters =>
    axios.get('/transactions/export/background', { params: { ...filters } }),
  getExportHolded: async filters => {
    const config = {
      responseType: 'blob',
      params: {
        ...filters
      }
    }

    return axios.get(`/transactions/export/holded`, config)
  },
  getExportNavision: async filters => {
    const config = {
      responseType: 'blob',
      params: {
        ...filters
      }
    }

    return axios.get(`/transactions/export/navision`, config)
  },
  getExportHistory: (page = 1) =>
    axios.get('/export_histories', { params: { page: page } }),

  /* Transaction Actions */
  putLockTransaction: transactionId =>
    axios.put(`/transactions/${transactionId}/lock`, {}),
  putUnlockTransaction: transactionId =>
    axios.put(`/transactions/${transactionId}/unlock`, {}),

  putReviewTransaction: transactionId =>
    axios.put(`/transactions/${transactionId}/review`, {}),
  putUnreviewTransaction: transactionId =>
    axios.put(`/transactions/${transactionId}/unreview`, {}),

  deleteTransaction: transactionId =>
    axios.delete(`/transactions/${transactionId}`),

  /* AEAT Integration */
  putReceipt: (receiptId, receiptData) =>
    axios.put(`/receipt/${receiptId}`, receiptData),
  getVatTypes: () => axios.get(`/vat_types`),
  /*  Transaction Tag Types */
  getBudgetTagTypes: (filters = {}, pagination = false, page = 1) => {
    return axios.get('/budget_tag_types', { params: { page: page, pagination: pagination, ...filters } })
  },
  getRecentTagTypes: (userId, tagTypeId) => {
    return axios.get(`/users/${userId}/last_tags_used/${tagTypeId}`)
  },
  /* Flexible Remuneration Transactions  */
  getFlexibleRemunerationTransactions: (
    page = 1,
    pagination = true,
    filters = {}
  ) => {
    return axios.get('/transactions/flexible_remuneration', {
      params: { page: page, ...filters }
    })
  },

  getExportBenefitsTransactionsPeriods: (page = 1, filters = {}) =>
    axios.get(`/users/flexible_remuneration/export/available/months`),
  getExportBenefitsTransactions: async filters => {
    const config = {
      responseType: 'blob',
      params: {
        ...filters
      }
    }
    return axios.get('/users/flexible_remuneration/export', config)
  },

  /* - Expenses -  */
  postExpense: expenseData => axios.post('/expenses', expenseData),
  getPaymentMethods: (page = 1, pagination = false, filters = {}) =>
    axios.get(`/payment_methods`, {
      params: { page: page, pagination: pagination, ...filters }
    }),
  getAllPaymentMethods: (page = 1, pagination = false, filters = {}) =>
    axios.get('/payment_methods/all', { params: { page: page, pagination: pagination, ...filters } }),
  getOfficePaymentMethods: (page = 1, pagination = false, filters = {}) =>
  axios.get('/office_payment_methods', { params: { page: page, pagination: pagination, ...filters } }),
  getMileageCategories: () => axios.get(`/mileage_categories`),
  /* -- Mileage Specific -- */
  postMileageCategory: mileageCategoryData =>
    axios.post('/mileage_categories', mileageCategoryData),
  putMileageCategory: (mileageCategoryId, mileageCategoryData) =>
    axios.put(`/mileage_categories/${mileageCategoryId}`, mileageCategoryData),

  /* - Tranactions 'Dashboard'  - */
  getTransactionsDashboard: (filters = {}) => {
    return axios({
      method: 'get',
      url: '/dashboard/transactions',
      params: {
        ...filters
      }
    })
  },

  getTopBanner: (filters = {}) => {
    if (cancelTopBanner !== undefined) {
      cancelTopBanner()
    }
    return axios({
      method: 'get',
      url: '/dashboard/transactions',
      cancelToken: new TopBannerCancelToken(function executor (c) {
        cancelTopBanner = c
      }),
      params: {
        ...filters
      }
    })
  },

  /* -- */
  /* Funnel Actions */
  putChangeReviewStatus: (id, reviewStatus) =>
    axios.put(`/transactions/${id}/review_status`, reviewStatus),

  postReviewSelectedTransactions: selectedTransactions =>
    axios.post('/transactions/funnel/review', selectedTransactions),
  postUnreviewSelectedTransactions: selectedTransactions =>
    axios.post('/transactions/funnel/un_review', selectedTransactions),
  postLockSelectedTransactions: selectedTransactions =>
    axios.post('/transactions/funnel/lock', selectedTransactions),
  postUnlockSelectedTransactions: selectedTransactions =>
    axios.post('/transactions/funnel/un_lock', selectedTransactions),
  postRejectSelectedTransactions: selectedTransactions =>
    axios.post('/transactions/funnel/reject', selectedTransactions),
  postAccountSelectedTransactions: selectedTransactions =>
    axios.post('/transactions/funnel/accounted', selectedTransactions),
  /*  Export */
  getExportSettingsHistory: (filters, pagination, page = 1) =>
    axios.get('/export_setting_histories', { params: { page: page, ...filters } })
}
